import { http } from '@/http/axios.js'
import axios from 'axios'
// 列表
export function getListAPI(data) {
  return http({
    url: `/api/admin/company/list`,
    method: 'get',
    params: data
  })
}
// detail
export function getDetailAPI(company_id) {
  return http({
    url: `/api/admin/company/detail`,
    method: 'get',
    params: { company_id }
  })
}
// add
export function addAPI(data) {
  return http({
    url: `/api/admin/company/add`,
    method: 'post',
    data
  })
}
// edit
export function editAPI(data) {
  return http({
    url: `/api/admin/company/edit`,
    method: 'post',
    data
  })
}
// del
export function delAPI(company_id) {
  return http({
    url: `/api/admin/company/del`,
    method: 'post',
    data: { company_id }
  })
}
export function changeStatusAPI(data) {
  return http({
    url: '/api/admin/company/updateShareQrcodeStatus',
    method: 'post',
    data
  })
}
export function downloadFile(pdfUrl, name) {
  axios({
    url: pdfUrl,
    method: 'GET',
    responseType: 'blob' // 必须指定为blob类型才能下载
  }).then(res => {
    const url = window.URL.createObjectURL(new Blob([res.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${name}.png`)
    document.body.appendChild(link)
    link.click()
  })
}
